<div class="field">
  <span class="field-title"
    >¿Cómo compra?<span class="asterisk" *ngIf="isRequired">*</span></span
  >
  <select-input
    class="input"
    [placeHolder]="'¿Cómo compra?'"
    [value]="elementSelected"
    [OBJECT]="purchaseMethods"
    [doFilterObject]="false"
    [enableSearch]="false"
    [array]="purchaseMethodOptions"
    [clearSearchOnSelect]="true"
    [disabled]="!isEditable"
    [isInvalid]="purchaseMethodStatus === PURCHASE_METHOD_STATUS.INVALID"
    (valueOut)="setValueWithEvent($event)"
  ></select-input>
  <!-- Explanatory note, not a validation status: shown regardless of purchaseMethodStatus
  (can appear alongside "Validando..." or a rejection), because it answers a different
  question -- why the value is fixed -- not what the integration is currently saying. -->
  <span class="field-hint" *ngIf="isFasonContract">Se compra en propiedad por tratarse de un Contrato Fasón.</span>
  <!-- ngSwitch guarantees at most one leyenda (R4): each case is a distinct branch of
  the same switch instead of independently toggled booleans that used to overlap. -->
  <ng-container [ngSwitch]="purchaseMethodStatus">
    <span class="loading" *ngSwitchCase="PURCHASE_METHOD_PENDING">{{ isAutocompletingPurchaseMethod ? 'Autocompletando...' : 'Validando...' }}</span>
    <span class="text-is-incomplete" *ngSwitchCase="PURCHASE_METHOD_STATUS.INVALID">{{ purchaseMethodMessageError }}</span>
    <span class="text-is-incomplete" *ngSwitchCase="PURCHASE_METHOD_STATUS.UNAVAILABLE">Ocurrió un problema, por favor,
      <button type="button" class="retry-link" (click)="retryPurchaseMethod.emit()">vuelva a intentar</button>.</span>
  </ng-container>
</div>
